import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import CpuSvg from '../../../assets/icons/app/cpu.svg?raw';

export const CpuIcon = (props) => <CustomSVG svg={CpuSvg} preserveColors appIconSmall {...props} />;
